import { defineStore } from 'pinia';
import { ref, Ref } from 'vue';
import { UserInfo } from '@bifrost-dev-docs-mfe/common/types/api';

const useUserStore = defineStore('user', () => {
  const info: Ref<UserInfo | undefined> = ref();
  return { info };
});

export default useUserStore;
